import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import {
  allDesignation,
  allQualification,
  allSpecialization,
  allRelevant_Training,
  allUsers,
} from "../../../../../../../features/admin/common/Slice";
import Select from "react-select";

import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingle,
  Update,
  GetAll,
  GetByUserId,
} from "../../../../../../../features/admin/quality_management/resource_requirement/personal_detail/Slice";

import { formatDateForInput } from "../../../../../../../utils/common";

function Personnel_Details_Edit_Offcanvas({ show, handleClose, id }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const all_designation = useSelector((state) => state.common.all_designation);
  const all_qualification = useSelector(
    (state) => state.common.all_qualification,
  );
  const all_specialization = useSelector(
    (state) => state.common.all_specialization,
  );
  const all_relevant_training = useSelector(
    (state) => state.common.all_relevant_training,
  );
  const authdetails = useSelector((state) => state.auth);

  const all_users = useSelector((state) => state.common.all_users);

  const isAdmin = authdetails?.role_id === 1;

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(allDesignation());
    dispatch(allQualification());
    dispatch(allSpecialization());
    dispatch(allRelevant_Training());
    dispatch(allUsers());
    //dispatch(GETAuthLogin());
  }, [dispatch]);

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.data;

        //map ID → label
        const designation = all_designation?.find(
          (o) => o.value === data.designation_id,
        )?.label;

        const qualification = all_qualification?.find(
          (o) => o.value === data.qualification_id,
        )?.label;

        const specialization = all_specialization?.find(
          (o) => o.value === data.specialization_id,
        )?.label;

        const relTraining = all_relevant_training?.find(
          (o) => o.value === data.relevant_training_id,
        )?.label;

        reset({
          name: data.name || "",
          contact_no: data.contact_no || "",
          email: data.email || "",
          experience: data.experience || "",
          designation_id: data.designation_id || null,
          qualification_id: data.qualification_id || null,
          specialization_id: data.specialization_id || null,
          relevant_training_id: data.relevant_training_id || null,
          degree: data.degree || null,
          training_certificate: data.training_certificate || null,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && id) {
      GetData(id);
    }
  }, [show, id]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data.name);
      sendData.append("contact_no", data.contact_no);
      sendData.append("email", data.email);
      sendData.append("experience", data.experience);

      //options
      sendData.append("designation_id", data.designation_id);
      sendData.append("qualification_id", data.qualification_id);
      sendData.append("specialization_id", data.specialization_id);
      sendData.append("relevant_training_id", data.relevant_training_id);

      //FIX: handle existing vs new file
      if (data.degree && typeof data.degree !== "string") {
        if (data.degree.length > 0) {
          sendData.append("degree", data.degree[0]);
        }
      }

      if (
        data.training_certificate &&
        typeof data.training_certificate !== "string"
      ) {
        if (data.training_certificate.length > 0) {
          sendData.append("training_certificate", data.training_certificate[0]);
        }
      }

      const res = await dispatch(Update({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAll());

        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      } else {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleRemoveCompanies = () => {
    setCompaniesPreview(null);
    setValue("degree", null);
    setRemovedFiles((prev) =>
      prev.includes("degree") ? prev : [...prev, "degree"],
    );
  };

  const handleRemoveAttach = () => {
    setAttachPreview(null);
    setValue("training_certificate", null);
    setRemovedFiles((prev) =>
      prev.includes("training_certificate")
        ? prev
        : [...prev, "training_certificate"],
    );
  };

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Personal Details
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    {...register("name", {
                      required: "Personal name is required",
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Contact No</Form.Label>
                  <Form.Control
                    {...register("contact_no", {
                      required: "Personal Contact No. is required",
                    })}
                  />
                  {errors.contact_no && (
                    <span className="text-danger">
                      {errors.contact_no.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    {...register("email", {
                      required: "Personnel Email is required",
                    })}
                  />
                  {errors.email && (
                    <span className="text-danger">{errors.email.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Experience</Form.Label>
                  <Form.Control
                    {...register("experience", {
                      required: "Personnel Experience is required",
                    })}
                  />
                  {errors.experience && (
                    <span className="text-danger">
                      {errors.experience.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Designation</Form.Label>
                  <Controller
                    name="designation_id"
                    control={control}
                    rules={{ required: "Designation is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_designation}
                        value={
                          all_designation?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.designation_id && (
                    <span className="text-danger">
                      {errors.designation_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Qualification</Form.Label>
                  <Controller
                    name="qualification_id"
                    control={control}
                    rules={{ required: "Qualification is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_qualification}
                        value={
                          all_qualification?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.qualification_id && (
                    <span className="text-danger">
                      {errors.qualification_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Specialization</Form.Label>
                  <Controller
                    name="specialization_id"
                    control={control}
                    rules={{ required: "Specialization is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_specialization}
                        value={
                          all_specialization?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.specialization_id && (
                    <span className="text-danger">
                      {errors.specialization_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Relevant Training</Form.Label>
                  <Controller
                    name="relevant_training_id"
                    control={control}
                    rules={{ required: "Relevant training is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_relevant_training}
                        value={
                          all_relevant_training?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.relevant_training_id && (
                    <span className="text-danger">
                      {errors.relevant_training_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              {/* Degree */}
              <div className="col-md-7">
                <Form.Group className="form_group file_field">
                  <Form.Label>Degree</Form.Label>
                  <Form.Control
                    type="file"
                    {...register("degree", {
                      validate: (value) => {
                        if (typeof value === "string") return true; // existing file
                        if (value && value.length > 0) return true; // new file
                        return "File is required";
                      },
                    })}
                    accept="*"
                  />
                  {errors.degree && (
                    <span className="text-danger">{errors.degree.message}</span>
                  )}
                  {(() => {
                    const fileValue = watch("degree");

                    let fileUrl = null;

                    if (typeof fileValue === "string" && fileValue) {
                      fileUrl = process.env.REACT_APP_IMG_URL + fileValue;
                    } else if (fileValue && fileValue.length > 0) {
                      fileUrl = URL.createObjectURL(fileValue[0]);
                    }

                    const fileType =
                      typeof fileValue === "string"
                        ? fileValue.toLowerCase()
                        : fileValue?.[0]?.type;

                    if (!fileUrl) return null;

                    return (
                      <div className="image_holder mt-2">
                        {(fileType?.includes("image") ||
                          fileType?.endsWith(".jpg") ||
                          fileType?.endsWith(".jpeg") ||
                          fileType?.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="img_preview"
                          />
                        )}

                        {/* PDF */}
                        {(fileType === "application/pdf" ||
                          fileType?.endsWith(".pdf")) && (
                          <iframe
                            src={fileUrl}
                            style={{ maxWidth: "100px" }}
                            title="PDF"
                            className="img_preview"
                          />
                        )}

                        {/* WORD */}
                        {(fileType?.includes("word") ||
                          fileType?.endsWith(".doc") ||
                          fileType?.endsWith(".docx")) && (
                          <div>
                            <p>Word preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                              className="img_preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType?.includes("spreadsheet") ||
                          fileType?.endsWith(".xlsx") ||
                          fileType?.endsWith(".xls")) && (
                          <div className="img_preview">
                            <p>Excel preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                  {/* <div className="image_holder">
                    <img
                      src={
                        companiesPreview ||
                        "/assets/images/other/dummy-image.png"
                      }
                      className="img_preview"
                      alt=""
                    />
                    {companiesPreview && (
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        className="delete_icon"
                        onClick={handleRemoveCompanies}
                      />
                    )}
                  </div> */}
                </Form.Group>
              </div>

              {/* Training Certificate */}
              <div className="col-md-7">
                <Form.Group className="form_group file_field">
                  <Form.Label>Training Certificate</Form.Label>
                  <Form.Control
                    type="file"
                    {...register("training_certificate", {
                      validate: (value) => {
                        if (typeof value === "string") return true; // existing file
                        if (value && value.length > 0) return true; // new file
                        return "File is required";
                      },
                    })}
                    accept="*"
                  />
                  {errors.training_certificate && (
                    <span className="text-danger">
                      {errors.training_certificate.message}
                    </span>
                  )}
                  {(() => {
                    const fileValue = watch("training_certificate");

                    let fileUrl = null;

                    if (typeof fileValue === "string" && fileValue) {
                      fileUrl = process.env.REACT_APP_IMG_URL + fileValue;
                    } else if (fileValue && fileValue.length > 0) {
                      fileUrl = URL.createObjectURL(fileValue[0]);
                    }

                    const fileType =
                      typeof fileValue === "string"
                        ? fileValue.toLowerCase()
                        : fileValue?.[0]?.type;

                    if (!fileUrl) return null;

                    return (
                      <div className="image_holder mt-2">
                        {(fileType?.includes("image") ||
                          fileType?.endsWith(".jpg") ||
                          fileType?.endsWith(".jpeg") ||
                          fileType?.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="img_preview"
                          />
                        )}

                        {/* PDF */}
                        {(fileType === "application/pdf" ||
                          fileType?.endsWith(".pdf")) && (
                          <iframe
                            src={fileUrl}
                            style={{ maxWidth: "100px" }}
                            title="PDF"
                            className="img_preview"
                          />
                        )}

                        {/* WORD */}
                        {(fileType?.includes("word") ||
                          fileType?.endsWith(".doc") ||
                          fileType?.endsWith(".docx")) && (
                          <div>
                            <p>Word preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                              className="img_preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType?.includes("spreadsheet") ||
                          fileType?.endsWith(".xlsx") ||
                          fileType?.endsWith(".xls")) && (
                          <div className="img_preview">
                            <p>Excel preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                  {/* <div className="image_holder">
                    <img
                      src={
                        companiesPreview ||
                        "/assets/images/other/dummy-image.png"
                      }
                      className="img_preview"
                      alt=""
                    />
                    {companiesPreview && (
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        className="delete_icon"
                        onClick={handleRemoveCompanies}
                      />
                    )}
                  </div> */}
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Personnel_Details_Edit_Offcanvas;
